import type { TTipoAmortizacaoEnum } from '@/features/simulacao/interfaces/simulacao.enum'
import type { TModoDeLucroDaEmpresa } from '@/shared/interfaces/empresa.enums'

export const TipoProdutoEnum = {
  Unidade: 'Unidade',
  Acessorio: 'Acessorio',
  VagaPadrao: 'VagaPadrao',
  Lote: 'Lote',
} as const
export type TTipoProdutoEnum = keyof typeof TipoProdutoEnum
export type TTipoProdutoVerticalEnum = Exclude<TTipoProdutoEnum, 'Lote'>
export type TTipoProdutoValidoEnum = Exclude<TTipoProdutoEnum, 'VagaPadrao'>

export const UnidadeTipoEnum = {
  Unidade: 'Unidade',
  Acessorio: 'Acessorio',
  Lote: 'Lote',
} as const
export type TUnidadeTipoEnum = keyof typeof UnidadeTipoEnum

export const ProdutoStatusEnum = {
  Disponivel: 'Disponivel',
  Reservada: 'Reservada',
  Indisponivel: 'Indisponivel',
  Vendida: 'Vendida',
} as const
export type TProdutoStatusEnum = keyof typeof ProdutoStatusEnum

export const ProdutoTipoLegendaStatusEnum = {
  Disponivel: 'Disponivel',
  ReservadoPeloVendedor: 'ReservadoPeloVendedor',
  ReservadoPorProposta: 'ReservadoPorProposta',
  Indisponivel: 'Indisponivel',
}
export type TProdutoTipoLegendaStatusEnum = keyof typeof ProdutoTipoLegendaStatusEnum

export interface ImobiliariasCorretores {
  id: string
  imobiliariaCorretorId: string
  percentualCorretagem: number
  valorCorretagem: number
}

export interface TCondicoesDePrecoProduto {
  id: string
  versao: number
  percentualISS: number
  percentualImpostos: number
  percentualIRPJ: number
  percentualINCC?: number
  dataPontoMedio: string
  modoDeLucroDaEmpresa: TModoDeLucroDaEmpresa
  dataSaldo: string
  dataAto: string
  dataSinal1: string
  dataSinal2: string
  dataSinal3: string
  dataSinal4: string
  dataPrimeiraMensal: string
  dataUltimaMensal: string
  dataDasIntermediarias: string[]
  previsaoDeEntregaDoBloco: string
  percentualComissaoVendedor: number
  patrimonioAfetacao: boolean
  percentualJurosAnualAntesPontoMedio: number
  percentualJurosAnualDepoisPontoMedio: number
  percentualAutonomiaVendedorSobrePoupanca1Por3: number
  percentualAutonomiaVendedorSobrePoupanca2Por3: number
  tipoDeAmortizacao?: TTipoAmortizacaoEnum
  totalDeMesesDoParcelamentoDeMensais?: number
}

export interface TTabelaDePrecoProduto {
  id: string
  versao: number
  valorBase: number
  custoEmUPF: number
  valorBaseAto: number
  valorBaseSinal: number
  valorBaseMensais: number
  valorBaseIntermediarias: number
  valorBaseSaldo: number
  percentualMargem: number
  margemVendedor1Por3: number
  margemVendedor2Por3: number
  margemVendedor3Por3: number
  margemGcom: number
  margemGR: number
  imobiliariasCorretores: ImobiliariasCorretores[]
}
